import { Error, RootState } from '@/store/types';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { ActionTree } from 'vuex';
import { RegionState, DataRegion } from './types';

export const actions: ActionTree<RegionState, RootState> = {
  get({ commit }): any {
    axios({
      url: '/regions',
      method: 'GET',
    }).then(
      (response: AxiosResponse) => {
        const payload: RegionState[] = response && response.data;
        commit('REGION_SUCCESS', payload);
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('REGION_ERROR', payload);
      },
    );
  },
  add({ commit }, region: DataRegion): any {
    return new Promise((resolve, reject) => {
      axios({
        url: '/regions',
        method: 'POST',
        data: region,
      }).then(
        () => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('REGION_ADD_ERROR', payload);
          reject();
        },
      );
    });
  },
  put({ commit }, region: DataRegion): any {
    return new Promise((resolve, reject) => {
      axios({
        url: `/regions/${region._id}`,
        method: 'PUT',
        data: region,
      }).then(
        () => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('REGION_PUT_ERROR', payload);
          reject();
        },
      );
    });
  },
  delete({ commit }, _id: string): any {
    return new Promise((resolve, reject) => {
      axios({
        url: `/regions/${_id}`,
        method: 'DELETE',
      }).then(
        () => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('REGION_DELETE_ERROR', payload);
          reject();
        },
      );
    });
  },
};
